import { Link, useParams } from 'react-router'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

export function NotFoundPage() {
  const { locale = 'fr' } = useParams<{ locale: string }>()
  useDocumentTitle('Page introuvable')

  return (
    <main className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 bg-background text-foreground">
      <h1 className="font-display text-4xl">404</h1>
      <p className="text-muted-foreground">Page introuvable</p>
      <Link to={`/${locale}`} className="text-accent hover:underline">
        Retour à l'accueil
      </Link>
    </main>
  )
}
